import { render, staticRenderFns } from "./InvitationTemplateList.vue?vue&type=template&id=023bac6e&scoped=true&"
import script from "./InvitationTemplateList.vue?vue&type=script&lang=js&"
export * from "./InvitationTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationTemplateList.vue?vue&type=style&index=0&id=023bac6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bac6e",
  null
  
)

export default component.exports